import { generatePath, useParams } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { HotelTop } from "@/components/features-new/hotel-top";

import type { ParamParseKey } from "react-router";

const useGetParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.TOP>>();

	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
		});
		throw new Error("Invalid URL");
	}

	return {
		hotelID: hotelID,
	};
};

const title = "トップ";

export const HotelTopPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta title={title} url={generatePath(PATHS.HOTEL.TOP, { hotelID })}>
			<HotelTop hotelID={hotelID} />
		</PageMeta>
	);
};

HotelTopPage.displayName = "HotelTopPage";
